import { Box } from '@mui/material'
import React from 'react'
import Faqs from './faqs'
import ValueProp from './ValueProp'
import ValueProp2 from './ValueProp2'
import ValueProp3 from './ValueProp3'
import ValueProp4 from './ValueProp4'
import JudgingCriteria from './JudgingCriteria'
import Footer from './footer'
import MetaTags from '../../component/MetaTags'
import ScoringChecklist from './scoring_checklist'
import TransitionValueProp from './TransitionValueProp'
import WinnerSection from './WinnerSection'
import NextContest from './NextContest'

function ContestPage() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        overflowY: "auto",
        maxWidth: "100%",
      }}
    >
      <MetaTags
        title="Soopra AI Persona Contest 2025 - Create Your AI Persona & Compete for $2,000 in Prizes"
        description='Turn your ideas into a living AI Persona and compete for cash prizes! The Soopra AI Persona Contest is your chance to create, customize, and showcase your AI twin that reflects your knowledge, creativity, or legacy.'
        image='https://soopra.ai/images/soopra_contest.png'
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: 'center',
          py:3,
          pb:0,
          pt: 0,
          gap: {xs: 0, md: 1.5},
          width: '100%',
          position: "relative",
        }}
        // maxWidth="lg"
      >
        {/* <ValueProp /> */}
        {/* <ValueProp3 />
        <ValueProp4 /> */}
        <TransitionValueProp />
        {/* <ValueProp2 /> */}
        <WinnerSection />
        <JudgingCriteria />
        {/* <ScoringChecklist /> */}
        {/* <Faqs /> */}
        {/* <Footer /> */}
        <NextContest />
      </Box>
    </Box>
  )
}

export default ContestPage